<div
  (click)="$event.stopPropagation()"
  class="h-24 w-64 overscroll-none bg-white">
  <div class="grid grid-cols-8 py-6 p-3 gap-2">
    <div *ngFor="let color of colors">
      <button (click)="colorSelect(color)" [style.background-color]="color.color" class="rounded h-5 w-5"></button>
    </div>
  </div>
</div>
